<template>
  <div :class="theme_type" class="page_text_font">
    <span class="first_name page_text_font">{{addressitem.first_name}}</span>
    <span v-if="theme_type=='showtime'" class="last_name page_text_font" :data-default="$t('account.default')">{{addressitem.last_name}}</span>
    <span v-else class="last_name page_text_font">{{addressitem.last_name}}</span>
    <br />
    <br v-if="theme_type=='venue'&&(addressitem.first_name||addressitem.last_name)" />
    <span>{{addressitem.company}}</span>
    <br />
    <br v-if="theme_type=='venue'&&addressitem.company" />
    <span>{{addressitem.address_1}}</span>
    <span>{{addressitem.address_2}}</span>
    <span>{{addressitem.city}}</span>
    <br />
    <br
      v-if="theme_type=='venue'&&(addressitem.address_1||addressitem.address_2||addressitem.city)"
    />
    <span>{{addressitem.postcode}}</span>
    <span v-html="province"></span>
    <br />
    <br v-if="theme_type=='venue'&&(addressitem.postcode||province)" />
    <span v-html="country"></span>
  </div>
</template>
<script>
export default {
  props: ["service", "addressitem", "theme_type"],
  data() {
    return {
      country: "",
      province: ""
    };
  },
  mounted() {
    this.service.some(item => {
      if (this.addressitem.country == item.code) {
        this.country = item.name;
        item.states.some(subitem => {
          if (this.addressitem.state == subitem.code) {
            this.province = subitem.name;
            return true;
          }
        });
        return true;
      }
    });
  }
};
</script>
<style scoped lang='scss'>
.venue {
  font-size: 15px;
  color: #535353;
  padding: 0;
}

.showtime {
  .first_name {
    font-size: 1.133em;
    color: #2f2f2f;
    font-weight: 700;
    font-family: 'Times New Roman', Times, serif;
  }

  .last_name {
    font-size: 1.133em;
    color: #2f2f2f;
    font-weight: 700;
    font-family: 'Times New Roman', Times, serif;
  }
}
</style>